<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb [title]="'MENUITEMS.ATTENDANCE.TEXT' | translate"
                      [items]="[('workCyclesCatalog.breadcrumb' | translate)]"></app-breadcrumb>
    </div>

    <div class="work-cycle-workspace"
         [class.work-cycle-workspace--loading]="isLoading">
      <mat-card class="work-cycle-panel work-cycle-panel--detail">
        <div class="work-cycle-panel__header"
             [class.work-cycle-panel__header--view]="isViewMode && !!selectedCycle">
          <div class="work-cycle-panel__heading"
               [class.work-cycle-panel__heading--view]="isViewMode && !!selectedCycle">
            @if (isViewMode && selectedCycle) {
            <div class="work-cycle-view-hero__icon" aria-hidden="true">
              <mat-icon>calendar_month</mat-icon>
            </div>
            }
            <div class="work-cycle-panel__heading-copy">
            <span class="work-cycle-panel__eyebrow">{{ 'workCyclesCatalog.breadcrumb' | translate }}</span>
            <div class="work-cycle-view-hero__title-row">
              <h3>{{ detailTitle }}</h3>
              @if (isViewMode && selectedCycle; as headerCycle) {
              <span class="work-cycle-view-status"
                    [class.work-cycle-view-status--inactive]="!headerCycle.isActive">
                <mat-icon>{{ headerCycle.isActive ? 'check_circle' : 'pause_circle' }}</mat-icon>
                {{ headerCycle.isActive ? ('common.status.active' | translate) : ('common.status.inactive' | translate) }}
              </span>
              }
            </div>
            @if (isViewMode && selectedCycle; as headerCycle) {
            <p class="work-cycle-view-hero__meta">
              <span>{{ getCompanyName(headerCycle.companiesRecordId) }}</span>
              @if (headerCycle.description?.trim() && headerCycle.description?.trim() !== '-') {
              <i aria-hidden="true"></i>
              <span>{{ headerCycle.description }}</span>
              }
            </p>
            } @else {
            <p>{{ detailDescription }}</p>
            }
            </div>
          </div>
          <div class="work-cycle-panel__actions">
            @if (selectedCycle && isViewMode) {
            <button mat-stroked-button
                    type="button"
                    class="btn-tone-primary"
                    *appCanAccess="updateAccess"
                    (click)="startEdit()">
              <mat-icon>edit</mat-icon>
              {{ 'common.update' | translate }}
            </button>
            <button mat-stroked-button
                    type="button"
                    class="btn-tone-danger"
                    *appCanAccess="deleteAccess"
                    (click)="deleteSelected()">
              <mat-icon>delete_outline</mat-icon>
              {{ 'common.delete' | translate }}
            </button>
            <button mat-stroked-button
                    type="button"
                    class="btn-tone-neutral"
                    (click)="goBackToList()">
              <mat-icon>arrow_back</mat-icon>
              {{ 'common.back' | translate }}
            </button>
            }
            @if (isCreateMode || isEditMode) {
            <button mat-stroked-button
                    type="button"
                    class="btn-tone-neutral"
                    (click)="cancelEdit()"
                    [disabled]="isSaving">
              <mat-icon>arrow_back</mat-icon>
              {{ 'common.cancel' | translate }}
            </button>
            <button mat-flat-button
                    type="button"
                    class="btn-tone-primary"
                    (click)="save()"
                    [disabled]="isSaving || !canSave">
              <mat-icon>save</mat-icon>
              {{ isCreateMode ? ('common.create' | translate) : ('common.saveChanges' | translate) }}
            </button>
            }
          </div>
        </div>

        <div class="work-cycle-panel__body">
          @if (isCreateMode || isEditMode) {
          <div class="work-cycle-editor">
            <div class="card work-cycle-editor__section mb-0">
              <div class="card-body">
                <div class="work-cycle-section-heading">
                  <div class="work-cycle-section-heading__title">
                    <h4>{{ 'workCyclesCatalog.sections.general' | translate }}</h4>
                    <span class="work-cycle-required-badge">{{ 'common.requiredLabel' | translate }}</span>
                  </div>
                  <p>{{ 'workCyclesCatalog.sections.generalDescription' | translate }}</p>
                </div>

                <div class="row g-3">
                  <div class="col-12 col-xl-4">
                    @if (hasMultipleCompanies) {
                    <app-company-select [records]="companies" [value]="form.companiesRecordId"
                                        [label]="'orgUnitsCatalog.fields.company' | translate"
                                        [placeholder]="'orgUnitsCatalog.fields.company' | translate"
                                        [disabled]="isSaving"
                                        (valueChange)="form.companiesRecordId = $event; selectedCompanyId = $event; onCompanyChange()" />
                    } @else {
                    <mat-form-field subscriptSizing="dynamic" appearance="outline">
                      <mat-label>{{ 'orgUnitsCatalog.fields.company' | translate }}</mat-label>
                      <input matInput [value]="getCompanyName(form.companiesRecordId)" readonly>
                    </mat-form-field>
                    }
                  </div>
                  <div class="col-12 col-xl-4">
                    <mat-form-field subscriptSizing="dynamic" appearance="outline">
                      <mat-label>{{ 'workCyclesCatalog.fields.name' | translate }}</mat-label>
                      <input matInput
                             [(ngModel)]="form.name"
                             [disabled]="isSaving"
                             [placeholder]="'workCyclesCatalog.fields.namePlaceholder' | translate">
                    </mat-form-field>
                  </div>
                  <div class="col-12 col-xl-4">
                    <mat-form-field subscriptSizing="dynamic" appearance="outline">
                      <mat-label>{{ 'workCyclesCatalog.fields.description' | translate }}</mat-label>
                      <input matInput
                             [(ngModel)]="form.description"
                             [disabled]="isSaving">
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>

            <div class="card work-cycle-editor__section mb-0">
              <div class="card-body">
                <div class="work-cycle-builder">
                  <div class="work-cycle-builder__main">
                <div class="work-cycle-section-heading">
                  <div class="work-cycle-section-heading__copy">
                    <div class="work-cycle-section-heading__title">
                      <h4>{{ 'workCyclesCatalog.sections.days' | translate }}</h4>
                      <span class="work-cycle-required-badge">{{ 'common.requiredLabel' | translate }}</span>
                    </div>
                    <p>{{ 'workCyclesCatalog.sections.daysDescription' | translate }}</p>
                  </div>
                </div>

                <div class="work-cycle-cycle-toolbar">
                  <div class="work-cycle-cycle-metrics">
                    <div><mat-icon>calendar_month</mat-icon><strong>{{ currentCycleLength }}</strong><span>días del ciclo</span></div>
                    <div><mat-icon>work</mat-icon><strong>{{ workDayCount }}</strong><span>laborables</span></div>
                    <div><mat-icon>bedtime</mat-icon><strong>{{ restDayCount }}</strong><span>descanso</span></div>
                    <div><mat-icon>schedule</mat-icon><strong>{{ cycleWorkDurationLabel }}</strong><span>del ciclo</span></div>
                  </div>
                  <div class="work-cycle-length-stepper">
                    <button mat-icon-button type="button" [disabled]="isSaving || currentCycleLength <= 1" (click)="decreaseCycleLength()">
                      <mat-icon>remove</mat-icon>
                    </button>
                    <strong>{{ currentCycleLength }} días</strong>
                    <button mat-icon-button type="button" [disabled]="isSaving || currentCycleLength >= 60" (click)="increaseCycleLength()">
                      <mat-icon>add</mat-icon>
                    </button>
                  </div>
                </div>

                  <div class="work-cycle-calendar-shell">
                    <div class="work-cycle-calendar" [style.--cycle-columns]="form.days.length || 1">
                    @for (day of form.days; track day.position) {
                    <article class="work-cycle-calendar__day"
                             [class.work-cycle-calendar__day--rest]="!isWorkDay(day)"
                             [class.work-cycle-calendar__day--selected]="selectedDayPosition === day.position"
                             role="button"
                             tabindex="0"
                             (click)="selectDay(day)"
                             (keydown.enter)="selectDay(day)">
                      <div class="work-cycle-calendar__day-heading">
                        <div>
                          <strong>DÍA {{ day.position }}</strong>
                          <span>{{ getCycleDayName(day.position) }}</span>
                        </div>
                      </div>

                      @if (isWorkDay(day)) {
                      <div class="work-cycle-calendar__status work-cycle-calendar__status--work">
                        <mat-icon>light_mode</mat-icon>
                        <strong>Laborable</strong>
                      </div>
                      <div class="work-cycle-calendar__times">
                        <strong><mat-icon>schedule</mat-icon>{{ getScheduleStartLabel(day.dailyScheduleId) }}</strong>
                        <mat-icon>south</mat-icon>
                        <strong>{{ getScheduleEndLabel(day.dailyScheduleId) }}</strong>
                      </div>
                      <div class="work-cycle-calendar__duration">
                        <mat-icon>schedule</mat-icon>
                        <div>
                          <strong>{{ getScheduleDurationLabel(day.dailyScheduleId) }}</strong>
                          <span>{{ getScheduleName(day.dailyScheduleId) }}</span>
                        </div>
                      </div>
                      } @else {
                      <div class="work-cycle-calendar__status work-cycle-calendar__status--rest">
                        <mat-icon>bedtime</mat-icon>
                        <strong>Descanso</strong>
                      </div>
                      <div class="work-cycle-calendar__rest">
                        <mat-icon>bedtime</mat-icon>
                        <span>Sin horario asignado</span>
                      </div>
                      <div class="work-cycle-calendar__duration work-cycle-calendar__duration--empty">
                        <strong>-</strong>
                      </div>
                      }
                    </article>
                    }
                    </div>
                  </div>
                  </div>

                  @if (selectedFormDay; as selectedDay) {
                  <aside class="work-cycle-day-editor">
                    <div class="work-cycle-day-editor__heading">
                      <div>
                        <span>CONFIGURAR</span>
                        <h5>Día {{ selectedDay.position }} · {{ getCycleDayName(selectedDay.position) }}</h5>
                      </div>
                      <div class="work-cycle-day-editor__state"
                           [class.work-cycle-day-editor__state--rest]="!isWorkDay(selectedDay)">
                        <mat-icon>{{ isWorkDay(selectedDay) ? 'light_mode' : 'bedtime' }}</mat-icon>
                        {{ isWorkDay(selectedDay) ? ('workCyclesCatalog.dayTypes.work' | translate) : ('workCyclesCatalog.dayTypes.rest' | translate) }}
                      </div>
                    </div>

                    <div class="work-cycle-day-editor__field">
                      <label>Tipo de día</label>
                      <div class="work-cycle-day-type-selector">
                        <button type="button"
                                [class.active]="isWorkDay(selectedDay)"
                                [disabled]="isSaving || !schedules.length"
                                (click)="setDayType(selectedDay, 'work')">
                          <mat-icon>light_mode</mat-icon>
                          Laborable
                        </button>
                        <button type="button"
                                [class.active]="!isWorkDay(selectedDay)"
                                [disabled]="isSaving"
                                (click)="setDayType(selectedDay, 'rest')">
                          <mat-icon>bedtime</mat-icon>
                          Descanso
                        </button>
                      </div>
                    </div>

                    @if (isWorkDay(selectedDay)) {
                    <div class="work-cycle-day-editor__field">
                      <mat-form-field subscriptSizing="dynamic" appearance="outline">
                        <mat-label>{{ 'workCyclesCatalog.fields.dailySchedule' | translate }}</mat-label>
                        <mat-select [ngModel]="selectedDay.dailyScheduleId"
                                    [ngModelOptions]="{standalone: true}"
                                    [disabled]="isSaving"
                                    (ngModelChange)="onDayScheduleChange(selectedDay, $event)">
                          @for (schedule of schedules; track schedule.dailyScheduleId) {
                          <mat-option [value]="schedule.dailyScheduleId">{{ schedule.name }}</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>

                    <div class="work-cycle-day-editor__time-grid">
                      <div><span>Hora de inicio</span><strong><mat-icon>schedule</mat-icon>{{ getScheduleStartLabel(selectedDay.dailyScheduleId) }}</strong></div>
                      <div><span>Hora de fin</span><strong><mat-icon>schedule</mat-icon>{{ getScheduleEndLabel(selectedDay.dailyScheduleId) }}</strong></div>
                    </div>
                    <div class="work-cycle-day-editor__duration">
                      <mat-icon>schedule</mat-icon>
                      <div><span>Duración de la jornada</span><strong>{{ getScheduleDurationLabel(selectedDay.dailyScheduleId) }}</strong></div>
                    </div>
                    } @else {
                    <div class="work-cycle-day-editor__rest-message">
                      <mat-icon>bedtime</mat-icon>
                      <strong>Día de descanso</strong>
                      <span>No requiere jornada ni horario diario.</span>
                    </div>
                    }
                  </aside>
                  }
                </div>
              </div>
            </div>
          </div>
          } @else if (selectedCycle; as cycle) {
          <div class="work-cycle-detail work-cycle-detail--view">
            <div class="work-cycle-view-metrics">
              <article class="work-cycle-view-metric">
                <div class="work-cycle-view-metric__icon"><mat-icon>calendar_month</mat-icon></div>
                <div>
                  <span>{{ 'workCyclesCatalog.fields.cycleLength' | translate }}</span>
                  <strong>{{ cycle.cycleLengthLabel }}</strong>
                  <small>Total de días del ciclo</small>
                </div>
              </article>
              <article class="work-cycle-view-metric">
                <div class="work-cycle-view-metric__icon"><mat-icon>business_center</mat-icon></div>
                <div>
                  <span>Días laborables</span>
                  <strong>{{ workDayCount }} días</strong>
                  <small>Días con horario asignado</small>
                </div>
              </article>
              <article class="work-cycle-view-metric work-cycle-view-metric--rest">
                <div class="work-cycle-view-metric__icon"><mat-icon>bedtime</mat-icon></div>
                <div>
                  <span>Días de descanso</span>
                  <strong>{{ restDayCount }} días</strong>
                  <small>Días sin jornada laboral</small>
                </div>
              </article>
            </div>

            <div class="card work-cycle-detail__section-card work-cycle-view-info mb-0">
              <div class="card-body">
                <div class="work-cycle-view-section-heading">
                  <div class="work-cycle-view-section-heading__icon"><mat-icon>description</mat-icon></div>
                  <div>
                    <h4>{{ 'workCyclesCatalog.sections.configuration' | translate }}</h4>
                    <p>{{ 'workCyclesCatalog.sections.configurationDescription' | translate }}</p>
                  </div>
                </div>
                <div class="work-cycle-view-info__grid">
                  <div class="work-cycle-view-info__item">
                    <span>{{ 'orgUnitsCatalog.fields.company' | translate }}</span>
                    <strong>{{ getCompanyName(cycle.companiesRecordId) }}</strong>
                  </div>
                  <div class="work-cycle-view-info__item">
                    <span>{{ 'workCyclesCatalog.fields.name' | translate }}</span>
                    <strong>{{ cycle.name }}</strong>
                  </div>
                  @if (cycle.description?.trim() && cycle.description?.trim() !== '-') {
                  <div class="work-cycle-view-info__item work-cycle-view-info__item--wide">
                    <span>{{ 'workCyclesCatalog.fields.description' | translate }}</span>
                    <strong>{{ cycle.description }}</strong>
                  </div>
                  }
                </div>
              </div>
            </div>

            <div class="card work-cycle-detail__section-card work-cycle-view-distribution mb-0">
              <div class="card-body">
                <div class="work-cycle-view-section-heading work-cycle-view-section-heading--distribution">
                  <div class="work-cycle-view-section-heading__icon"><mat-icon>calendar_view_week</mat-icon></div>
                  <div class="work-cycle-view-section-heading__copy">
                    <h4>{{ 'workCyclesCatalog.sections.days' | translate }}</h4>
                    <p>{{ 'workCyclesCatalog.sections.daysDescription' | translate }}</p>
                  </div>
                  <div class="work-cycle-view-legend" aria-label="Leyenda">
                    <span><i class="work-cycle-view-legend__work"></i>Horario laboral</span>
                    <span><i class="work-cycle-view-legend__rest"></i>Descanso</span>
                  </div>
                </div>

                <div class="work-cycle-view-layout">
                  <div class="work-cycle-planner work-cycle-planner--view">
                  <div class="work-cycle-planner__chunk">
                    <div class="work-cycle-planner__grid"
                         [style.--planner-columns]="cycle.days.length || 1">
                      <div class="work-cycle-planner__corner">Horario</div>
                      @for (day of form.days; track day.position) {
                      <div class="work-cycle-planner__day-card"
                           [class.work-cycle-planner__day-card--rest]="!isReadOnlyWorkDay(day)"
                           [class.work-cycle-planner__day-card--selected]="selectedDayPosition === day.position"
                           role="button"
                           tabindex="0"
                           (click)="selectDay(day)"
                           (keydown.enter)="selectDay(day)">
                        <div class="work-cycle-planner__day-head">
                          <div class="work-cycle-planner__day-head-main">
                            <span>Día {{ day.position }}</span>
                            <strong>{{ getCycleDayName(day.position) }}</strong>
                          </div>
                          @if (isReadOnlyWorkDay(day)) {
                          <div class="work-cycle-planner__day-status work-cycle-planner__day-status--work">
                            <mat-icon>light_mode</mat-icon>
                            <span>{{ 'workCyclesCatalog.dayTypes.work' | translate }}</span>
                          </div>
                          } @else {
                          <div class="work-cycle-planner__day-status work-cycle-planner__day-status--rest">
                            <mat-icon>bedtime</mat-icon>
                            <span>{{ 'workCyclesCatalog.dayTypes.rest' | translate }}</span>
                          </div>
                          }
                        </div>
                      </div>
                      }

                      @for (slot of hourSlots; track slot.label) {
                      <div class="work-cycle-planner__row-label work-cycle-planner__row-label--time">{{ slot.label }}</div>
                      @for (day of form.days; track day.position) {
                      <div class="work-cycle-planner__cell">
                        <div class="work-cycle-planner__hour-slot"
                             [class.work-cycle-planner__hour-slot--filled]="isHourSlotCovered(day, slot.start)"
                             [class.work-cycle-planner__hour-slot--rest]="!isReadOnlyWorkDay(day)">
                          @if (getHourSlotFill(day, slot.start); as fill) {
                          @if (fill.filled) {
                          <div class="work-cycle-planner__hour-fill"
                               [style.left.%]="fill.left"
                               [style.width.%]="fill.width">
                          </div>
                          }
                          }
                        </div>
                      </div>
                      }
                      }
                    </div>
                  </div>
                  </div>

                  @if (selectedFormDay; as selectedDay) {
                  <aside class="work-cycle-view-day-detail">
                    <div class="work-cycle-view-day-detail__heading">
                      <div>
                        <span>Día seleccionado</span>
                        <h5>Día {{ selectedDay.position }} · {{ getCycleDayName(selectedDay.position) }}</h5>
                      </div>
                      <span class="work-cycle-view-day-detail__type"
                            [class.work-cycle-view-day-detail__type--rest]="!isWorkDay(selectedDay)">
                        <mat-icon>{{ isWorkDay(selectedDay) ? 'light_mode' : 'bedtime' }}</mat-icon>
                        {{ isWorkDay(selectedDay) ? ('workCyclesCatalog.dayTypes.work' | translate) : ('workCyclesCatalog.dayTypes.rest' | translate) }}
                      </span>
                    </div>

                    @if (isWorkDay(selectedDay)) {
                    <div class="work-cycle-view-day-detail__schedule">
                      <span>{{ 'workCyclesCatalog.fields.dailySchedule' | translate }}</span>
                      <strong>{{ getScheduleName(selectedDay.dailyScheduleId) }}</strong>
                      <div><mat-icon>schedule</mat-icon>{{ getScheduleTimeRange(selectedDay.dailyScheduleId) }}</div>
                    </div>
                    <div class="work-cycle-view-day-detail__facts">
                      <div><mat-icon>wb_sunny</mat-icon><span>Tipo de día</span><strong>Laboral</strong></div>
                      <div><mat-icon>timer</mat-icon><span>Duración</span><strong>{{ getScheduleDurationLabel(selectedDay.dailyScheduleId) }}</strong></div>
                      <div><mat-icon>business_center</mat-icon><span>Jornada</span><strong>{{ getJourneyName(selectedDay.journeyId) }}</strong></div>
                    </div>
                    <div class="work-cycle-view-day-detail__note">
                      <mat-icon>info</mat-icon>
                      <span>Este día tiene un horario laboral configurado dentro del ciclo.</span>
                    </div>
                    } @else {
                    <div class="work-cycle-view-day-detail__rest-state">
                      <mat-icon>bedtime</mat-icon>
                      <strong>Día de descanso</strong>
                      <span>No tiene jornada ni horario asignado.</span>
                    </div>
                    }
                  </aside>
                  }
                </div>
              </div>
            </div>
          </div>
          } @else {
          <div class="work-cycle-empty">
            <mat-icon>event_repeat</mat-icon>
            <h4>{{ 'workCyclesCatalog.emptyEditorTitle' | translate }}</h4>
            <p>{{ 'workCyclesCatalog.emptyEditorDescription' | translate }}</p>
          </div>
          }
        </div>
      </mat-card>

      @if (isLoading) {
      <app-loading-state class="work-cycle-loading"
                         [message]="'workCyclesCatalog.loading' | translate" />
      }
    </div>
  </div>
</section>
